import * as types from "../types/zone.types";
import { getZoneList, getStoreList, postDashboardlist, postZoneValidateLocation, postZoneStoreAdd, patchZoneEdit, getZoneStoreSingle } from '../../services/zone.service';
import { validationErrors } from "../../utils/Helpers";

export const getZoneListAction = (data, navigate) => {
  return async (dispatch, getState)  => {
    // console.log("in getZoneListAction: ",getState().authReducer.token)
    try {
      await getZoneList(getState().authReducer.token, getState().authReducer.user.id).then((res) => {
        if(res.data.code === 200){
          dispatch({
            type: types.SET_ZONE_DATA,
            payload: res.data.data,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const getStoreListAction = (data, navigate) => {
  return async (dispatch, getState)  => {
    // console.log("in getZoneListAction: ",getState().authReducer.token)
    try {
      await getStoreList(getState().authReducer.token, getState().authReducer.user.id).then((res) => {
        // console.log('getZoneList res.data: ',res.data);
        if(res.data.code === 200){
          dispatch({
            type: types.SET_STORE_DATA,
            payload: res.data.data,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};

const viewdata = (values)=>{
  if (values.longestPendingOrder === null){
    const valda ={
      ...values,
      longestPendingOrder:{
        order_duration : 0,
      }
    }
    return valda;
  } else {
    return values;
  }
}
export const getDashboardListAction = (data, name) => async (dispatch, getState) => {
  let request_status = false;
  let return_data = [];
  try {
    await postDashboardlist(getState().authReducer.token, getState().authReducer.user.id, data).then((res) => {
      if(res.data.code === 200){
        res.data.data.store_name_local = name;
        res.data.data.storeId = data;
        let rs_dashboard_data = {...getState().ZoneReducer.dashboardData, [`storeId_${data}`]: viewdata(res.data.data)};

        dispatch({
          type: types.SET_DASHBOARD_DATA,
          payload: rs_dashboard_data,
        });
        return_data = res.data.data;
        request_status = true;
      }
    });
  } catch (e) {
    // validationErrors(e);
  }
  if (request_status) return return_data;
  else return false;
};

export const getDashboardFilterAction = (data) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_DASHBOARD_DATA_FILTER,
      payload: data,
    });
  };
};
export const setDashboardDataAction = (data) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_DASHBOARD_DATA,
      payload: data,
    });
  };
};

export const postZoneValidateLocationAction = (zId, data) => {
  return async (dispatch, getState)  => {
    try {
      await postZoneValidateLocation(getState().authReducer.token, getState().authReducer.user.id, zId, data).then((res) => {
        if(res.data.code === 200){
          dispatch({
            // type: types.SET_ZONE_DATA,
            // payload: res.data.data,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const singleZoneStoreAction = (id) => {
  return async (dispatch, getState) => {
    try {
      await getZoneStoreSingle(getState().authReducer.token, getState().authReducer.user.id, id).then((res) => {
        if (res.data.code === 200) {
          dispatch({
            type: types.SET_ZONE_VIEW_DATA,
            payload: res.data.data,
          });
        }
      })
    } catch (e) {validationErrors(e)}
  };
};

export const postZoneStoreAction = (data) => {
  return async (dispatch, getState) => {
    try {
      return postZoneStoreAdd(getState().authReducer.token, getState().authReducer.user.id, data);
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const patchZoneAction = (data, id) => {
  return async (dispatch, getState) => {
    try {
      return patchZoneEdit(getState().authReducer.token, getState().authReducer.user.id, data, id);
    } catch (e) {
      validationErrors(e);
    }
  };
};